/* eslint-disable no-undef */
/* eslint no-param-reassign: "off" */

export default {
  install(Vue) {
    Vue.prototype.$gmaps = {
      latLng2Point(latLng, map) {
        // https://stackoverflow.com/questions/25219346/how-to-convert-from-x-y-screen-coordinates-to-latlng-google-maps
        const topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
        const bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
        const scale = Math.pow(2, map.getZoom());
        const worldPoint = map.getProjection().fromLatLngToPoint(latLng);
        const x = (worldPoint.x - bottomLeft.x) * scale;
        const y = (worldPoint.y - topRight.y) * scale;
        return new google.maps.Point(x, y);
      },
      geoRect(xMin, xMax, yMin, yMax) {
        return [
          { lat: xMin, lng: yMax }, { lat: xMin, lng: yMin },
          { lat: xMax, lng: yMin }, { lat: xMax, lng: yMax }
        ];
      },
      getBounds(path) {
        if (path && Array.isArray(path) && path.length) {
          const bounds = new google.maps.LatLngBounds();
          path.forEach((item) => bounds.extend(item));
          return bounds;
        }
        return null;
      },
      drawHoleArea(map, area) {
        if (!area || !Array.isArray(area) || !area.length) return null;
        const paths = [
            this.geoRect(-85, 85, 0, 180),
            this.geoRect(-85, 85, -180, 0),
            area
          ];

        return new google.maps.Polygon({
            map,
            paths,
            strokeColor: '#000000',
            strokeOpacity: 0.0,
            strokeWeight: 1,
            fillColor: '#000000',
            fillOpacity: 0.5,
            draggable: false,
            editable: false,
            clickable: false,
            geodesic: false
          });
      },
    };
  }
};
